// 时刻类字段（后端返回 Unix 秒）按浏览器本地时区渲染，固定 ISO 风格 YYYY-MM-DD HH:mm:ss
// 与小程序端 uview 'yyyy-mm-dd hh:MM:ss' 输出对齐；locale 入参保留仅为兼容旧调用，不再影响分隔符
export function formatDateTime(epochSec, locale) {
  if (!epochSec) return "---";
  const d = new Date(epochSec * 1000);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(
    d.getHours()
  )}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

// 日历日期类字段（后端返回 "YYYY-MM-DD" 纯字符串）只做书写格式本地化，不做时区换算
// 两端必须同时锚定 UTC：拼 T00:00:00Z 构造 + 传 timeZone:'UTC' 格式化，
// 否则 ECMA-402 缺省按运行时本地时区，西半球浏览器会少一天
export function formatDateOnly(isoDate, locale) {
  if (!isoDate) return "---";
  return new Intl.DateTimeFormat(locale, {
    dateStyle: "medium",
    timeZone: "UTC",
  }).format(new Date(isoDate + "T00:00:00Z"));
}
